<div class="sticky z-1">
  <header class="flex py-5">
    <div class="mx-auto">
      <img src="assets/img/motorola-logo.svg" alt="Motorola Branding" class="motorola-branding">
    </div>
  </header>

  <main class="information-body m-auto">
    <div class="mx-5 pb-5">
      <app-download></app-download>
    </div>

    <div class="mx-auto text-left pt-5 pb-7">
      <div class="mx-5">
        <div class="mb-5">
          <h2 [translate]="'app.download.shareFeedback'" class="information-title"></h2>
          <p [innerHTML]="'app.download.shareFeedbackMessage' | translate" class="information-message"></p>
        </div>
        <div class="m-auto">
          <ng-lottie
            *ngIf="animationData"
            [options]="{ animationData: animationData }">
          </ng-lottie>
        </div>
        <div class="mt-5">
          <h2 [translate]="'app.download.readyToStopBetaTesting'" class="information-title"></h2>
          <p [translate]="'app.download.readyToStopBetaTestingMessage' | translate" class="information-message"></p>
        </div>

        <button pButton class="p-button-outlined my-5" (click)="redirectToFrequentlyAskedQuestions()">
          <img src="assets/img/ic_forward.svg" alt="Frequently Asked Questions" class="m-auto">
          <p [translate]="'app.download.frequentlyAskedQuestions'" class="pl-2 asked-question-button-text"></p>
        </button>
      </div>
    </div>
  </main>
</div>

<footer class="information-footer">
  <span class="background-gradient"></span>
</footer>
